'use es6';

import PropTypes from 'prop-types';
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import ObjectTypesType from 'customer-data-objects-ui-components/propTypes/ObjectTypesType';
import { ExpandableSection } from 'foundations-components/transitional/components/ExpandableSection';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const UniversalSidebarCardDragPreview = ({
  item: {
    data: cardData
  },
  width
}) => {
  const {
    Title,
    Actions,
    objectId,
    objectType,
    data,
    cardProps
  } = cardData;
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-default",
    children: /*#__PURE__*/_jsx(ExpandableSection, {
      open: false,
      titleText: /*#__PURE__*/_jsx(Title, Object.assign({
        data: data,
        objectId: objectId,
        objectType: objectType,
        subjectId: objectId /* todo subjectId -> objectId */
      }, cardProps)),
      actions: Actions && /*#__PURE__*/_jsx(Actions, {
        data: data,
        objectType: objectType,
        objectId: objectId
      }),
      style: {
        width
      }
    })
  });
};
UniversalSidebarCardDragPreview.propTypes = {
  item: PropTypes.shape({
    data: PropTypes.shape({
      Title: PropTypes.elementType.isRequired,
      Actions: PropTypes.elementType,
      objectId: PropTypes.string.isRequired,
      objectType: PropTypes.oneOfType([ObjectTypesType, ObjectTypeIdType]).isRequired,
      data: PropTypes.object
    })
  }),
  width: PropTypes.number
};
export default UniversalSidebarCardDragPreview;